// Shared bits for the vertical-template pages (list + detail): the per-vertical
// icon tile, its tint, and the read-only "Define para sus bots" list.

import { type TemplateDefine, type VerticalKey } from './templates-data.js'

export const VERTICAL_WRAP: Record<VerticalKey, string> = {
  salud: 'bg-ok-bg text-ok',
  empeno: 'bg-warn-bg text-warn',
  autos_nuevos: 'bg-info-bg text-info',
  autos_seminuevos: 'bg-[color-mix(in_srgb,var(--brand-blue)_12%,transparent)] text-link',
  medico: 'bg-ok-bg text-ok',
}

const PATHS: Record<VerticalKey, JSX.Element> = {
  salud: (
    <>
      <path d="M20.8 12.7a7 7 0 0 0-12 6.6L12 22l3.2-2.7a7 7 0 0 0 5.6-6.6Z" />
      <path d="M12 6V3M9 4.5h6" />
    </>
  ),
  empeno: (
    <>
      <path d="M4 8h16l-1.5 12.4a2 2 0 0 1-2 1.6H7.5a2 2 0 0 1-2-1.6L4 8Z" />
      <path d="M9 8V5a3 3 0 1 1 6 0v3" />
    </>
  ),
  autos_nuevos: (
    <>
      <path d="M3 13l2-5a2 2 0 0 1 2-1.5h10A2 2 0 0 1 19 8l2 5v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" />
      <circle cx="7" cy="16" r="1.4" />
      <circle cx="17" cy="16" r="1.4" />
    </>
  ),
  autos_seminuevos: (
    <>
      <path d="M3 13l2-5a2 2 0 0 1 2-1.5h10A2 2 0 0 1 19 8l2 5v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1H7v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" />
      <circle cx="7" cy="16" r="1.4" />
      <circle cx="17" cy="16" r="1.4" />
      <path d="M9 6l1-2h4l1 2" />
    </>
  ),
  medico: (
    <>
      <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 20a8 8 0 0 1 16 0" />
    </>
  ),
}

export function VerticalIcon({ vertical }: { vertical: VerticalKey }): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {PATHS[vertical]}
    </svg>
  )
}

function AlertIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
      <path d="M12 9v4m0 4h.01" />
    </svg>
  )
}
function DotIcon(): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M5 12h14" />
    </svg>
  )
}

export function DefinesList({ defines }: { defines: TemplateDefine[] }): JSX.Element {
  return (
    <ul className="flex flex-col gap-2">
      {defines.map((d, i) => (
        <li key={i} className="flex items-start gap-2 text-[12px] leading-snug text-text-2">
          <span
            className={`mt-px flex-none [&_svg]:size-[13px] ${d.nonNegotiable ? 'text-warn' : 'text-text-3'}`}
          >
            {d.nonNegotiable ? <AlertIcon /> : <DotIcon />}
          </span>
          <span className="flex-1">
            {d.text}
            {d.nonNegotiable && (
              <span className="ml-1.5 rounded-pill bg-warn-bg px-1.5 py-px text-[9.5px] font-bold uppercase tracking-[0.03em] text-warn">
                No negociable
              </span>
            )}
          </span>
        </li>
      ))}
    </ul>
  )
}
